<a (click)="action()" class="thumbnail" style="background-image:url('{{ backgroundImage }}'); ">
  {{ label }}
  <!-- Actions and Icons -->
  <div class="actions">
    <i class="glyphicon glyphicon-ban-circle error" *ngIf="softwareService && !softwareService.isEnabled; else errorAndWarningIcons">
    </i>
    <ng-template #errorAndWarningIcons>
      <i class="glyphicon glyphicon-exclamation-sign error" *ngIf="error">
      </i>
      <i class="glyphicon glyphicon-warning-sign warning" *ngIf="!error && warning">
      </i>
    </ng-template>
    <span *ngIf="isComingSoon">
      <i class="glyphicon glyphicon-bullhorn warning">
      </i>
      Coming Soon!
    </span>
    <i class="glyphicon glyphicon-cog"
      *ngIf="hasSettings && !error && !isComingSoon && softwareService && softwareService.isEnabled"
      (click)="goToSettings()">
    </i>
  </div>

  <!-- Errors and Warnings -->
  <div class="error" *ngIf="isComingSoon || (softwareService && !softwareService.isEnabled); else errorAndWarningMessages">
    <div class="bold">
      <i class="glyphicon glyphicon-exclamation-sign"></i>
      This service is not enabled.
    </div>
  </div>

  <ng-template #errorAndWarningMessages>
    <div *ngIf="error" class="error">
      <div class="bold">
        <i class="glyphicon glyphicon-exclamation-sign"></i>
        {{ error }}
      </div>
    </div>
  
    <div *ngIf="!error && warning" class="warning">
      <div class="bold">
        <i class="glyphicon glyphicon-warning-sign"></i>
        {{ warning }}
      </div>
    </div>
  </ng-template>
</a>